import Styles from '../assets/styles.scss';
import { IUserMessageProps } from '../entities/IUserMessageProps';

const UserMessage: React.FC<IUserMessageProps> = props => {
	return <div className={`${Styles.message} ${Styles.user}`}>{props.message.content}</div>;
};

export { UserMessage };
